import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './LoginButton.styles';

const LoginButton = props => {
  const { styles: customStyles, ...rest } = props;
  return (
    <button className={css(styles.base, customStyles)} {...rest}>
      {props.children}
    </button>
  );
};

export default LoginButton;



// WEBPACK FOOTER //
// ./src/components/inputs/loginbutton/LoginButton.js